<template>
    <v-layout>
    <nav-drawer v-if="isAuthenticated" />

    <app-bar v-if="isAuthenticated" />

    <v-main>
        <router-view></router-view>
    </v-main>

    <!-- Popup Confirm: utilisé partout dans le projet -->
    <confirm-popup ref="confirm" />
    <validate-popup ref="validate" />

    <!-- Footer -->
    <Footer />
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import { APIAccount } from "./store/api";
import NavDrawer from "@/components/layout/NavDrawer";
import AppBar from "@/components/layout/AppBar";
import ConfirmPopup from "@/components/helpers/ConfirmPopup";
import ValidatePopup from "@/components/helpers/ValidatePopup";
import Footer from './components/layout/Footer.vue';

export default {
  name: "App",
  components: {
    NavDrawer,
    AppBar,
    ConfirmPopup,
    ValidatePopup,
    Footer,
  },
  data () {
    return {
      drawer: true,
    }
  },
  beforeCreate() {
    this.$store.commit("initializeStore")

    let access = localStorage.getItem("access")
    
    if (access) {
      APIAccount.defaults.headers.common['Authorization'] = `Berear ${access}`

      APIAccount.get('/me/')
      .then(response => {
        this.$store.commit('setUser', {
              id: response.data.id,
              email: response.data.email,
              is_superuser: response.data.is_superuser,
              is_staff: response.data.is_staff,
              last_name: response.data.last_name,
              first_name: response.data.first_name,
              fullname: response.data.fullname,
              gender: response.data.gender,
              gender_value: response.data.gender_value,
              entity: response.data.entity,
              entity_id: response.data.entity_id,
              job: response.data.job,
              job_id: response.data.job_id,
              phone: response.data.phone,
              photo: response.data.photo?.toString().includes('http') ? response.data.photo : 'user.png',
              signature: response.data.signature?.toString().includes('http') ? response.data.signature : '',
              pages_autocomplete: response.data.pages_autocomplete,
              pages_list: response.data.pages_list,
              is_chief : response.data.is_chief,
              is_general_manager : response.data.is_general_manager,
              permissions: response.data.permissions,
          })
          this.$store.commit('setAuthentication', true)
          this.$router.push(this.$route.query.redirect || "/");
      }).catch(error => {
        console.log(error.message);
      })
    }
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
    this.$root.$validate = this.$refs.validate.open;

    setInterval(() => {
      this.$store.dispatch('refreshToken')
    }, 59000);
  },
  computed: {
    ...mapState({
      user: state => state.user,
      isAuthenticated: state => state.isAuthenticated,
    }),
  },
}
</script>
